import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import InitialAvatar from 'components/shared/avatar/initial';
import startCase from 'lodash/startCase'
import ModalHandler from 'components/shared/modal/modal-handler'
import PassportInviteModal from 'components/shared/modals/passport-invite'
import passportActions from 'actions/passport/actions'
import RemoveIcon from 'components/shared/icons/remove'
import RemoveGuestModal from 'components/shared/modals/remove-guest'

const Members = ({ invitedMembers, user_id, passportInviteCorporate, clientDeletePassportInvitation }) => {
  const buttonInvite = (<button className="btn-primary mx-2 w-40 py-2 border border-primary-orange text-sm rounded font-semibold">Invite</button>)
  const button = useRef()

  return (
    <div className="shadow-md bg-white m-5 p-5">
      <h3 className="text-base font-semibold">Invited Members</h3>
      <p className="text-primary-lightgray text-xs">
        Invite members of your organization to share your passport plan.
      </p>
      <ul className="border-t my-5">
        {invitedMembers.map(({ name, image, status, date, id, passportInvitationId, type, bookingTime, space }, key) => (
          <li className="flex w-full justify-between items-center border-b py-3" key={key}>
            <div className="flex">
              {image ? (
                <img alt={name} src={image} className="h-10 w-10 mr-4" />
              ) : (
                <InitialAvatar initial={name.charAt(0)} className="h-10 w-10 mr-4 text-2xl" />
              )}
              <div>
                <p className="font-bold text-sm">{name}</p>
                <p className="text-xs">{startCase(status)}</p>
              </div>
            </div>
            <div className="flex">
              <div className="text-xs font-semibold text-center">{date}</div>
              <div className="text-center flex justify-center items-center w-16">
                {user_id !== id && (
                  <ModalHandler
                    title={
                      <button ref={button}>
                        <RemoveIcon />
                      </button>
                    }
                    className="hover:text-primary-orange pt-1"
                  >
                    {({ toggle }) => (
                      <RemoveGuestModal
                        onClose={toggle}
                        onSubmit={() => {
                          clientDeletePassportInvitation(passportInvitationId)
                        }}
                        guestType={type}
                        bookingTime={bookingTime}
                        bookingSpace={space}
                      />
                    )}
                  </ModalHandler>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
      <div className="flex items-center justify-center">
        <ModalHandler title={buttonInvite}>
          {({ toggle }) => (
            <PassportInviteModal
              onClose={toggle}
              handleSubmit={(values) => {
                passportInviteCorporate(values)
                toggle()
              }}>
            </PassportInviteModal>
          )}
        </ModalHandler>
      </div>
    </div>
  )
}

Members.propTypes = {
  invitedMembers: PropTypes.array,
  passportInviteCorporate: PropTypes.func,
  user_id: PropTypes.number,
  clientDeletePassportInvitation: PropTypes.func,
}

const mapDispatchToProps = {
  passportInviteCorporate: passportActions.passportInviteCorporate,
  clientDeletePassportInvitation: passportActions.clientDeletePassportInvitation,
}

export default connect(null, mapDispatchToProps)(Members)
